import '../../components/saxs/saxs.css'

import { Alert, Col, Grid, Row } from 'react-bootstrap'
import { CREATE_MACROMOLECULE_VIEW, EDIT_MACROMOLECULE_VIEW, MACROMOLECULE_WELCOME_VIEW } from '../../constants/saxs'
import { ERROR_MESSAGE_TYPE, INFO_MESSAGE_TYPE } from '../../constants/UserMessages'
import { getMacromoleculeById, getProposalIdByProposalName } from '../../helpers/Saxs/SaxsProposalManager'

import Loading from '../../components/Loading'
import MacromoleculeWelcomePage from '../../components/saxs/Macromolecule/MacromoleculeWelcomePage'
import React from 'react'
import SaxsMacromoleculeListPanel from '../../components/saxs/Macromolecule/SaxsMacromoleculeListPanel'
import SaxsNewOrEditMacromolecule from '../../components/saxs/Macromolecule/SaxsNewOrEditMacromolecule'
import SaxsSideBar from '../../components/saxs/SaxsSideBar'
import UserMessage from '../../components/saxs/UserMessage'
import { axios } from 'config/axios'
import { connect } from 'react-redux'
import { fetchProposalInfoAction } from '../../actions/proposalInfo'
import qs from 'qs'
import { saveMacromolecule } from '../../api/ispyb'

const EMPTY_MACROMOLECULE = {
  macromoleculeId: null,
  acronym: '',
  comments: '',
  extintionCoefficient: '',
  molecularMass: '',
  name: '',
  proposal: '',
  refractiveIndex: '',
  solventViscosity: '',
  symmetry: 'P1',
}

/**
 * React Container used to prepare a SAXS experiment concerning macromolecule
 */
class SaxsMacromoleculesContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      errorMessage: null,
      message: null,
      selectedMacromolecule: EMPTY_MACROMOLECULE,
      view: MACROMOLECULE_WELCOME_VIEW,
    }

    this.onSaveButtonClicked = this.onSaveButtonClicked.bind(this)
    this.saveMacromolecule = this.saveMacromolecule.bind(this)
    this.setViewAndMacromoleculeId = this.setViewAndMacromoleculeId.bind(this)
  }

  render() {
    if (this.props.user.username === null || this.props.user.token === null) {
      return null
    }

    if (Object.entries(this.props.application).length === 0 || !this.props.application.activeProposal) {
      return (
        <Alert bsStyle="warning">
          <strong>Wait</strong> Please select a proposal first.
        </Alert>
      )
    }

    // handles the loader
    if (this.props.proposalInfo.fetching === true) {
      return <Loading />
    }

    // handles http request failure
    if (this.props.proposalInfo.fetched === false && this.props.proposalInfo.fetching === false) {
      return (
        <Grid fluid>
          <Row>
            <Col xs={12}>
              <UserMessage type={ERROR_MESSAGE_TYPE} message="Retrieval of the data failed." />
            </Col>
          </Row>
        </Grid>
      )
    }

    // handles case when data have been recieved
    if (this.props.proposalInfo.fetched === true) {
      return (
        <SaxsSideBar
          sideBarComponent={
            <SaxsMacromoleculeListPanel
              proposalInfo={this.props.proposalInfo.data}
              setViewAndMacromoleculeId={this.setViewAndMacromoleculeId}
            />
          }
        >
          <Grid fluid style={{ marginTop: '10px' }}>
            {this.state.message ? (
              <Row>
                <Col xs={12}>
                  <UserMessage type={INFO_MESSAGE_TYPE} message={this.state.message} />
                </Col>
              </Row>
            ) : null}

            {this.state.errorMessage ? (
              <Row>
                <Col xs={12}>
                  <UserMessage type={ERROR_MESSAGE_TYPE} message={this.state.errorMessage} />
                </Col>
              </Row>
            ) : null}

            <Row>
              <Col xs={12}>
                {this.state.view === MACROMOLECULE_WELCOME_VIEW ? (
                  <MacromoleculeWelcomePage setView={this.setViewAndMacromoleculeId} />
                ) : null}
                {this.state.view === CREATE_MACROMOLECULE_VIEW ? (
                  <SaxsNewOrEditMacromolecule
                    activeProposal={this.props.application.activeProposal.name}
                    onSaveButtonClicked={this.onSaveButtonClicked}
                    proposalInfo={this.props.proposalInfo}
                    selectedMacromolecule={EMPTY_MACROMOLECULE}
                    setView={this.setViewAndMacromoleculeId}
                  />
                ) : this.state.view === EDIT_MACROMOLECULE_VIEW ? (
                  <SaxsNewOrEditMacromolecule
                    activeProposal={this.props.application.activeProposal.name}
                    onSaveButtonClicked={this.onSaveButtonClicked}
                    proposalInfo={this.props.proposalInfo}
                    selectedMacromolecule={this.state.selectedMacromolecule}
                    setView={this.setViewAndMacromoleculeId}
                  />
                ) : null}
              </Col>
            </Row>
          </Grid>
        </SaxsSideBar>
      )
    }
  }

  /**
   * Set the view and the macromoleculeId
   * @param {String} view view
   * @param {number} macromoleculeId macromolecule identifier
   */
  setViewAndMacromoleculeId(view, macromoleculeId) {
    if (view === CREATE_MACROMOLECULE_VIEW || view === MACROMOLECULE_WELCOME_VIEW) {
      this.setState({ view: view, message: null, errorMessage: null })
    } else if (view === EDIT_MACROMOLECULE_VIEW && macromoleculeId) {
      this.setState({
        view: view,
        selectedMacromolecule: getMacromoleculeById(macromoleculeId, this.props.proposalInfo.data),
        message: null,
        errorMessage: null,
      })
    }
  }

  onSaveButtonClicked(macromolecule) {
    const proposalId = getProposalIdByProposalName(
      this.props.application.activeProposal.name,
      this.props.proposalInfo.data
    )
    macromolecule.proposalId = proposalId

    this.saveMacromolecule(macromolecule).then(
      () => {
        this.props.fetchProposalInfo(this.props.user, this.props.application.activeProposal.name)
        this.setState({
          view: MACROMOLECULE_WELCOME_VIEW,
          message: 'Macromolecule successfully created.',
          macromolecule: EMPTY_MACROMOLECULE,
        })
      },
      () => {}
    )
  }

  /**
   * Save the macromolecule, handles the request to the server
   * @param {*} macromolecule
   * @returns {Promise} promise
   */
  saveMacromolecule(macromolecule) {
    return axios({
      method: 'POST',
      url: saveMacromolecule(this.props.user, this.props.application.activeProposal.name),
      data: qs.stringify({ macromolecule: JSON.stringify(macromolecule) }),
      headers: { 'content-type': 'application/x-www-form-urlencoded;charset=utf-8' },
    }).then(
      data => data,
      error => {
        this.setState({ errorMessage: 'Failed creating/updating the data to the server.' })
        return error
      }
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    application: state.application,
    proposalInfo: state.proposalInfo,
    proposals: state.proposals,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchProposalInfo: (user, proposal) => dispatch(fetchProposalInfoAction(user, proposal)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SaxsMacromoleculesContainer)
